var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9650_23578)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.022 15.5504C23.5456 19.0775 20.0615 21.5556 15.9986 21.5556C11.9354 21.5556 8.45112 19.0772 6.97489 15.5497L6.58263 15.3209C5.60202 14.7489 4.99903 13.699 4.99903 12.5638C4.99903 11.5023 5.52619 10.5155 6.39629 9.92416C7.26244 5.41042 11.2322 2 15.9986 2C20.7647 2 24.7344 5.41008 25.6008 9.92348C26.4715 10.5148 26.999 11.5019 26.999 12.5638C26.999 13.699 26.396 14.7489 25.4154 15.3209L25.022 15.5504ZM11.6487 6.41261C9.81921 6.62435 8.36518 8.0371 8.17102 9.86853C8.09724 10.5645 8.04326 11.2787 8.0412 11.8905C8.03886 12.5815 8.10189 13.3995 8.18652 14.1806C8.37913 15.9584 9.75801 17.3501 11.528 17.6042C12.9532 17.8088 14.647 18 15.9996 18C17.2809 18 18.8684 17.8284 20.2438 17.6364C22.1259 17.3737 23.534 15.8286 23.7374 13.9392L23.9072 12.3626C23.941 12.0488 23.9404 11.7322 23.9056 11.4185L23.7599 10.1076C23.5445 8.1685 22.0626 6.6048 20.1238 6.38673C18.7756 6.23509 17.2417 6.10254 15.9996 6.10254C14.6872 6.10254 13.0493 6.25051 11.6487 6.41261ZM7.14341 19.5249C4.13584 20.6749 2 23.5879 2 26.9998V29.9998C2 30.5521 2.44771 30.9998 3 30.9998H8V29C8 27.8954 8.89543 27 10 27H22C23.1046 27 24 27.8954 24 29V30.9998H29C29.5523 30.9998 30 30.5521 30 29.9998V26.9998C30 23.5879 27.8642 20.6749 24.8566 19.5249C22.8535 22.2392 19.6323 23.9998 16 23.9998C12.3677 23.9998 9.14655 22.2392 7.14341 19.5249ZM23 30.9998V29C23 28.4477 22.5523 28 22 28H10C9.44772 28 9 28.4477 9 29V30.9998H23Z",
    fill: "#15171C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9650_23578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.b78668ae65ee6d38a200ea64b4eedc02.svg";
export { ForwardRef as ReactComponent };